<template>
  <v-text-field
    v-model="keyword"
    append-icon="search"
    v-on:blur="handleBlur"
    placeholder="名前/電話番号/メールアドレス"
    @keyup.enter="search()"
    class="UXinput UXicon-search"
    style="max-width: 500px;"
    hide-details
    outline
    solo
  ></v-text-field>
</template>

<script>
import TicketListUtil from '../../../util/ticket_list_util'
import OptionType from '../../../enums/ticketListOptionType'

export default {
  name: 'search_customer_keyword',
  props: {
    updateOption: Function,
    pageType: String
  },
  data () {
    return {
      keyword: ''
    }
  },
  methods: {
    search () {
      this.updateOption('customerSearch', this.keyword)
    },
    handleBlur () {
      this.search()
    },
    resetAll () {
      this.keyword = null
    }
  },
  mounted () {
    this.keyword = TicketListUtil.parseJsonIntoOption(this.pageType, OptionType.CUSTOMER_SEARCH, localStorage.getItem('TICKET_LIST_OPTION'))
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/menus/ticket/component/ticketlist/input/search_customer_keyword.vue